// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-y2U","title":"styles_title__78Sow"};